import Radium from "radium";
import React, { Component } from "react";
import { Link } from "react-router";
import { connect } from 'react-redux';
import { semanticColors } from "../Globals/styles";
import { httpGet } from "../Util/http";
import "./table.css";
import { setNavHeader } from "../MainClient/Navbar/actions";

class Users extends Component {
  constructor(props) {
    super(props);
    this.state = {
      users: [],
      skip: 0,
      take: 25,
      query: "",
      disabled: false,
    };
  }

  componentDidMount() {
    this.props.dispatch(setNavHeader(true, "Brugere"))
    this.query();
  }

  query(skip, take, append, disabled, query = "") {
    httpGet(
      process.env.REACT_APP_webApiEndPoint +
      `api/user/searchv2?query=${query}&skip=${skip === undefined ? this.state.skip : skip
      }&take=${take === undefined ? this.state.take : take}&disabled=${disabled === undefined ? this.state.disabled : disabled
      }`
    )
      .then((res) => res.json())
      .then((resp) => {
        if (append) {
          this.setState({ users: [...this.state.users, ...resp.users] });
        } else {
          this.setState({ users: resp.users });
        }
      });
  }

  render() {
    return (
      <div id="users" style={styles.page}>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <Link to={"/users/create-new"}>
            <button className="btn btn-primary">Opret bruger</button>
          </Link>
          <div style={{ display: "flex" }}>
            <div style={{ display: "flex", marginRight: 6 }}>
              <div
                style={styles.seeAll}
                onClick={() => {
                  this.setState({
                    disabled: false,
                  });
                  this.query(
                    0,
                    this.state.take,
                    false,
                    false,
                    this.state.query
                  );
                }}
                className={
                  this.state.disabled ? "btn btn-default" : "btn btn-info"
                }
              >
                Aktive
              </div>
              <div
                style={styles.seeFavorite}
                onClick={() => {
                  this.setState({
                    disabled: true,
                  });
                  this.query(0, this.state.take, false, true, this.state.query);
                }}
                className={
                  !this.state.disabled ? "btn btn-default" : "btn btn-info"
                }
              >
                Blokerede
              </div>
            </div>
            <input
              value={this.state.query}
              onChange={(evt) => {
                const search = evt.target.value;
                this.query(
                  0,
                  this.state.take,
                  false,
                  this.state.disabled,
                  search
                );
                this.setState({
                  query: search,
                  skip: 0,
                });
              }}
              placeholder="Søg..."
            />
          </div>
        </div>
        <div style={styles.container} className="flex-gap">
          <table style={{ margin: 6 }}>
            <thead>
              <th>Navn</th>
              <th>Lønnummer</th>
              <th>Email</th>
              <th>Rolle</th>
              <th></th>
            </thead>
            <tbody>
              {this.state.users.map((user) => (
                <tr key={user.aggregateId}>
                  <td>{user.fullname}</td>
                  <td>{user.username}</td>
                  <td>{user.email}</td>
                  <td>{user.role}</td>
                  <td>
                    <Link to={`users/${encodeURIComponent(user.username)}`}>
                      <button className="btn btn-primary">rediger</button>
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <div style={styles.indlaes}>
            {this.state.query ? null : (
              <button
                onClick={() => {
                  const skip = this.state.skip + this.state.take;
                  this.setState({
                    skip,
                  });
                  this.query(skip, this.state.take, true, this.state.disabled);
                }}
                className="btn btn-primary"
              >
                Indlæs flere
              </button>
            )}
          </div>
        </div>
      </div>
    );
  }
}

const styles = {
  page: {
    position: "absolute",
    paddingTop: "70px",
    top: "0",
    left: "0",
    height: "100%",
    width: "100%",
    "@media (min-width: 1200px)": {
      left: "50%",
      marginLeft: "-585px",
      maxWidth: "1170px",
    },
    overflow: "hidden",
  },
  container: {
    display: "flex",
    justifyContent: "flex-start",
    flexDirection: "column",
    marginTop: 24,
    backgroundColor: semanticColors.default,
    height: "100%",
    overflow: "auto",
  },
  indlaes: {
    marginBottom: 100,
    backgroundColor: "transparent",
    display: "flex",
    justifyContent: "center",
  },
  seeAll: {
    width: "50px",
    height: "35px",
    lineHeight: "35px",
    padding: "0px",
    marginLeft: "15px",
    borderTopRightRadius: "0px",
    borderTopLeftRadius: "2px",
    borderBottomLeftRadius: "2px",
    borderBottomRightRadius: "0px",
  },
  seeFavorite: {
    width: "100px",
    height: "35px",
    lineHeight: "35px",
    padding: "0px",
    borderTopLeftRadius: "0px",
    borderTopRightRadius: "2px",
    borderBottomRightRadius: "2px",
    borderBottomLeftRadius: "0px",
  },
};
export default connect()(Radium(Users));



// WEBPACK FOOTER //
// ./src/App/Users/index.jsx